import React from "react";
import {useTranslation} from "react-i18next";
import "../../../assets/styles/modules/pages/search-preferences/search-preferences-header.scss";

const SearchPreferencesHeader = ({
  title = "SEARCH_PREFERENCES_HEADER_TITLE",
  description = "SEARCH_REGIONS_PREFERENCES_HEADER_DESCRIPTION",
}) => {
  const {t} = useTranslation();

  return (
    <div className="search-preferences-header">
      <div className="search-preferences-header__title-container">
        <h1 className="search-preferences-header__title">{t(title)}</h1>
      </div>
      <p className="search-preferences-header__description">{t(description)}</p>
    </div>
  );
};

export default SearchPreferencesHeader;
